import React, { useEffect, useState, useRef } from "react";
import { fetchResidualPortfolio } from "../../../../services/residuals";
import styles from "./style.module.scss";
import useResidualStore from "../../../../stores/residuals";
import SkeletonLoader from "../../../../components/skeleton-loader";

const ResidualStats = () => {
  const filters = useResidualStore((state) => state.filters);
  const [portfolio, setPortfolio] = useState({
    total_volume: "0.00",
    total_last_month_residual: "0.00",
    total_projected_residual: null,
  });
  const [loading, setLoading] = useState(false);
  const carouselRef = useRef(null);

  useEffect(() => {
    const fetchCurrentMonthData = async () => {
      setLoading(true);
      try {
        const data = await fetchResidualPortfolio(filters);
        setPortfolio({
          total_volume: data.total_volume ?? "0.00",
          total_last_month_residual: data.total_last_month_residual ?? "0.00",
          total_projected_residual: data.total_projected_residual ?? null,
        });
      } catch (error) {
        console.error('Error fetching current month portfolio:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentMonthData();
  }, [filters]);

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "$0.00";

    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(parseFloat(amount));
    } catch (error) {
      return "$0.00";
    }
  };

  const formatProjectedResidual = (amount) => {
    if (amount === null || amount === undefined) {
      return "--";
    }

    return formatCurrency(amount);
  };

  const getStatItems = () => {
    const projected = formatProjectedResidual(portfolio.total_projected_residual);

    return [
      {
        header: "Portfolio Volume",
        amount: formatCurrency(portfolio.total_volume),
        title: formatCurrency(portfolio.total_volume),
      },
      {
        header: "Last month Residual",
        amount: formatCurrency(portfolio.total_last_month_residual),
        title: formatCurrency(portfolio.total_last_month_residual),
      },
      {
        header: "Projected Residual",
        amount: projected,
        title: projected,
      },
    ];
  };

  const statItems = getStatItems();

  if (loading) {
    return (
      <div className={styles.stats_container}>
        <div className={styles.carousel_wrapper}>
          <div className={styles.carousel_track}>
            {[1, 2, 3].map((i) => (
              <div key={i} className={styles.stat_card}>
                <div className={styles.stat_content}>
                  <SkeletonLoader
                    variant="rectangular"
                    height={14}
                    width={140}
                    className={styles.skeleton_header}
                  />
                  <SkeletonLoader variant="rectangular" height={28} width={100} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.stats_container}>
      <div className={styles.carousel_wrapper} ref={carouselRef}>
        <div className={styles.carousel_track}>
          {statItems.map((item, index) => (
            <div key={index} className={styles.stat_card}>
              <div className={styles.stat_content}>
                <div className={styles.header}>{item.header}</div>
                <div className={styles.amount} title={item.title}>{item.amount}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResidualStats;
